import React , { useCallback,useEffect,useState,useContext } from 'react';
import { Table,Spin,Input,Modal,Button,message,Select,InputNumber,Popover} from 'antd';

import _ from "lodash";
import { APIrequest } from '../../Helpers.js'
import { parseRules } from '../Projections/Scoring'
import { UserContext } from "../../Contexts/UserContext";
// import { useReactToPrint } from 'react-to-print';
function Admin (props) {
    const { userID } =
    useContext(UserContext);
    
    const [loading,setLoading]=useState(false)
    
      const refreshMFLplayer = async ()=>{
        console.log("Fetching Projections")
        setLoading(true)
        const data=APIrequest(`/api/mfl/getMFLplayers`,{
            headers : {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }}).then(d=>{setLoading(false);return 1})
        return 1
      }

      const refreshKTCvalues = async ()=>{
        console.log("Fetching Projections")
        setLoading(true)
        const data=APIrequest(`/api/ktc/values`,{
            headers : {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }}).then(d=>{setLoading(false);console.log(d);return 1})
        return 1
      }

      const refreshFantasyCalcValues = async ()=>{
        console.log("Fetching Values")
        setLoading(true)
        const data=APIrequest(`/api/ktc/scrapeFantasyCalcValues`,{
            headers : {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
             }}).then(d=>{setLoading(false);console.log(d);return 1})
        return 1
      }
      

    
    const spinner=
    <React.Fragment>
    <Spin />
    </React.Fragment>
    

    return (
        <div>
           <Button onClick={()=>refreshKTCvalues()}>KTC Values</Button>
           <Button onClick={()=>refreshFantasyCalcValues()}>FantasyCalc Values</Button>
           <Button onClick={()=>refreshMFLplayer()}>MFL Players</Button>

           {loading? spinner:<div/>}
        </div>
        
        )
        
    }

    export default Admin;


